module.exports = __webpack_public_path__ + "img/drive.4c673cc5.png";